import { API } from "aws-amplify";
import { debounce } from "lodash";
import Router, { useRouter } from "next/router";
import { useEffect, useRef, useState } from "react";
import StyledLink from "../../../../shared/components/global/StyledLink";
import { Job } from "../../../../shared/model/Job";
import { SearchbarButton, SearchbarCityInput, SearchbarContainer, SearchbarTextInput, SearchbarTypeAhead } from '../../../../shared/styles/jobs/searchbar';
import { searchJobs } from "../../graphql/queries";
import ButtonSearchSVG from '/public/svg/jobs/search.svg';

export default function JobsSearchbar({ top }) {

    const wrapperRef = useRef<any>(null);

    const router = useRouter()
    const [initial, setInitial] = useState<boolean>(true)
    const [what, setWhat] = useState<string>('');
    const [where, setWhere] = useState<string>('');
    const [typeahead, setTypeahead] = useState<Job[]>([])

    useEffect(() => {
        if (initial) {
            let searchParams = new URLSearchParams(window.location.search);
            const searchParamsWhat: any = searchParams.get('what');
            const searchParamsWhere: any = searchParams.get('where');
            searchParamsWhat != null ? setWhat(searchParamsWhat) : setWhat('')
            searchParamsWhere != null ? setWhere(searchParamsWhere) : setWhere('')
            setInitial(false)
        }
    }, [router]);

    const useOutsideAlerter = (ref, setTypeahead) => {
        useEffect(() => {
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    setTypeahead([]);
                }
            }
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);
    }
    useOutsideAlerter(wrapperRef, setTypeahead);

    const debouncedSearch = useRef(
        debounce(async (what, where) => {
            changeHandler(what, where);
        }, 300)
    ).current;

    const changeHandler = (what, where) => {
        const variables = {}
        variables['limit'] = 6;
        variables['filter'] = {};
        const whatHasValue = what != null && what?.length > 0;
        const whereHasValue = where != null && where?.length > 0;
        if (whatHasValue) {
            variables['filter']['and'] = [];
            const newOr: any = [];
            newOr.push({ title: { matchPhrasePrefix: what } })
            newOr.push({ category: { matchPhrasePrefix: what } })
            variables['filter']['and'].push({ or: newOr });
        }
        if (whereHasValue) variables['filter']['city'] = { matchPhrasePrefix: where }

        if (whatHasValue || whereHasValue) {
            fetchTypeAheadAsync(variables);
        } else {
            setTypeahead([]);
        }
    };

    const fetchTypeAheadAsync = async (variables) => {
        const response: any = await API.graphql({
            query: searchJobs,
            variables: variables,
            authMode: 'API_KEY'
        });
        let jobs: Job[] = response.data.searchJobs?.items;
        jobs = jobs
            .filter(job => job.expiresAt != null && job.expiresAt?.length > 0 && new Date(job.expiresAt) > new Date())
        setTypeahead(jobs);
    }

    const handleKeyDown = async (event) => {
        if (event.key === 'Enter') {
            setTypeahead([]);
            handleSearch();
        }
    }

    const onChangeWhat = (newWhat) => {
        setWhat(newWhat);
        debouncedSearch(newWhat, where);
    }
    const onChangeWhere = (newWhere) => {
        setWhere(newWhere);
        debouncedSearch(what, newWhere);
    }

    const handleSearch = () => {
        let searchParams = new URLSearchParams(window.location.search);
        searchParams.set('what', what);
        searchParams.set('where', where);
        Router.push('/jobs/search?' + searchParams.toString());
    }

    const getUrlForTypeahead = (title, city) => {
        let searchParams = new URLSearchParams(window.location.search);
        if (what != null && what?.length > 0 && title != null && title.length > 0) searchParams.set('what', title);
        if (where != null && where?.length > 0 && city != null && city.length > 0) searchParams.set('where', city);
        return '/jobs/search?' + searchParams.toString();
    }

    return (
        <SearchbarContainer top={top} ref={wrapperRef}>
            <div className="searchbar-subcontainer">
                <SearchbarTextInput
                    type="text"
                    placeholder="Suche nach Jobtitel oder Kompetenz"
                    value={what}
                    onChange={(event) => onChangeWhat(event.target.value)}
                    withTypeahead={typeahead?.length > 0}
                    onKeyDown={handleKeyDown}>
                </SearchbarTextInput>
                <SearchbarCityInput
                    type="text"
                    placeholder="Standort"
                    value={where}
                    onChange={(event) => onChangeWhere(event.target.value)}
                    withTypeahead={typeahead?.length > 0}
                    onKeyDown={handleKeyDown}>
                </SearchbarCityInput>
                <SearchbarTypeAhead>
                    <ul>
                        {typeahead?.map((entry, index) =>
                            <StyledLink key={entry?.title + index} href={getUrlForTypeahead(entry?.title, entry?.city)} onClick={() => setTypeahead([])}>
                                <li>{entry?.title}</li>
                            </StyledLink>
                        )}
                    </ul>
                </SearchbarTypeAhead>
            </div>

            <SearchbarButton type="button" onClick={() => handleSearch()}>
                Jobs finden <ButtonSearchSVG />
            </SearchbarButton>
        </SearchbarContainer>
    )
}
